import { galleries } from '../utils/galleryImages';

const IMAGE_BASE_PATH = "/images"

export const preloadImages = () => {
    Object.entries(galleries).forEach(([galleryName, imageList]) => {
        imageList.forEach((filename) => {
            const img = new Image();
            img.src = `${IMAGE_BASE_PATH}/${galleryName}/${filename}`;
        });
    });
};